// ...imports
import React, { useEffect, useState } from "react";
import { FaPlus, FaTrash } from "react-icons/fa";

const ProductBundleCreate = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  const schoolId = localStorage.getItem("school_id");
  const added_by = localStorage.getItem("id");

  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  const [classes, setClasses] = useState([]);

  const [form, setForm] = useState({
    category_id: "",
    subcategory_id: "",
    product_name: "",
    product_type: "general",
  });

  // variants UI-তে spacing আরও ভালো লাগার জন্য placeholder গুলোও দিলাম
  const [variants, setVariants] = useState([
    {
      variant_name: "",
      class_id: "",          // selected class id (if book)
      class_name: "",        // for searchable datalist
      height_range: "",
      weight_range: "",
      size: "",
      cost_price: "",
      sale_price: "",
      initial_stock_qty: "",
    },
  ]);

  const categoryURL   = `https://dgps.co.in/api/product/category/list?school_id=${schoolId}`;
  const subcategoryURL= `https://dgps.co.in/api/product/subcategory/list`;
  const createURL     = `https://dgps.co.in/api/product/bundle/create`;
  const classesURL    = `https://dgps.co.in/api/get-classes`;

  // classes (for book) – searchable datalist এর জন্য পুরো লিস্ট লাগবে
  useEffect(() => {
    fetch(classesURL)
      .then(r => r.json())
      .then(d => setClasses(d?.data || []))
      .catch(() => {});
  }, []);

  // categories
  useEffect(() => {
    fetch(categoryURL)
      .then(r => r.json())
      .then(d => setCategories(d || []))
      .catch(() => {});
  }, [categoryURL]);

  // subcategories (category change এ load)
  useEffect(() => {
    if (!form.category_id) {
      setSubcategories([]);
      setForm(f => ({ ...f, subcategory_id: "" }));
      return;
    }
    fetch(`${subcategoryURL}?category_id=${form.category_id}`)
      .then(r => r.json())
      .then(d => setSubcategories(d || []))
      .catch(() => {});
  }, [form.category_id, subcategoryURL]);

  const handleForm = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const addVariantRow = () => {
    setVariants(prev => ([
      ...prev,
      {
        variant_name: "",
        class_id: "",
        class_name: "",
        height_range: "",
        weight_range: "",
        size: "",
        cost_price: "",
        sale_price: "",
        initial_stock_qty: "",
      },
    ]));
  };

  const removeVariantRow = (idx) => {
    setVariants(prev => prev.filter((_, i) => i !== idx));
  };

  // 🔎 variant state আপডেট
  const handleVariantChange = (idx, name, value) => {
    setVariants(prev => {
      const copy = [...prev];
      copy[idx][name] = value;
      return copy;
    });
  };

  // 🔎 searchable class datalist থেকে নির্বাচন করলে class_id resolve করা
  const handleClassPick = (idx, typedName) => {
    // typedName == class_name; find its id from classes
    const found = classes.find(c => (c.class_name || "").toLowerCase() === typedName.toLowerCase());
    setVariants(prev => {
      const copy = [...prev];
      copy[idx].class_name = typedName;
      copy[idx].class_id   = found ? found.id : "";   // মেলেনি হলে id খালি
      return copy;
    });
  };

  const resetAll = () => {
    setForm({
      category_id: "",
      subcategory_id: "",
      product_name: "",
      product_type: "general",
    });
    setVariants([
      {
        variant_name: "",
        class_id: "",
        class_name: "",
        height_range: "",
        weight_range: "",
        size: "",
        cost_price: "",
        sale_price: "",
        initial_stock_qty: "",
      },
    ]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!schoolId) return alert("Missing school id");
    if (!form.subcategory_id || !form.product_name) return alert("Please fill product details correctly.");
    if (!variants.length) return alert("Add at least one variant");

    const payload = {
      school_id: Number(schoolId),
      added_by: Number(added_by),
      subcategory_id: Number(form.subcategory_id),
      product: {
        product_name: form.product_name,
        product_type: form.product_type,
      },
      variants: variants.map(v => ({
        variant_name: v.variant_name,
        class_id: v.class_id || null,            // datalist resolve থেকে আসবে
        height_range: v.height_range || null,
        weight_range: v.weight_range || null,
        size: v.size || null,
        cost_price: Number(v.cost_price || 0),
        sale_price: Number(v.sale_price || 0),
        initial_stock_qty: Number(v.initial_stock_qty || 0),
      })),
    };

    try {
      const res = await fetch(createURL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      const data = await res.json();
      if (data.status === "success") {
        alert("✅ Product + Variants + Stock created!");
        resetAll();
      } else {
        alert("❌ " + (data.message || "Failed"));
      }
    } catch (err) {
      console.error(err);
      alert("Something went wrong!");
    }
  };

  // ---------- UI ----------
  return (
    <div style={{ display: "flex", minHeight: "100vh", backgroundColor: "#f4f6f8" }}>
      <div style={{ flex: 1 }}>
        <main style={{ padding: 30, maxWidth: 1100, margin: "0px auto" }}>
          <section style={cardStyle}>
            <h2 style={titleStyle}>➕ Create Product Bundle</h2>

            <form onSubmit={handleSubmit}>
              {/* Top form */}
              <div style={grid2}>
                <FormGroup label="Category">
                  <select
                    name="category_id"
                    value={form.category_id}
                    onChange={handleForm}
                    style={inputStyle}
                    required
                  >
                    <option value="">-- Select Category --</option>
                    {categories.map(c => (
                      <option key={c.id} value={c.id}>{c.category_name}</option>
                    ))}
                  </select>
                </FormGroup>

                <FormGroup label="Subcategory">
                  <select
                    name="subcategory_id"
                    value={form.subcategory_id}
                    onChange={handleForm}
                    style={inputStyle}
                    required
                  >
                    <option value="">-- Select Subcategory --</option>
                    {subcategories.map(s => (
                      <option key={s.id} value={s.id}>{s.subcategory_name}</option>
                    ))}
                  </select>
                </FormGroup>

                <FormGroup label="Product Name">
                  <input
                    type="text"
                    name="product_name"
                    value={form.product_name}
                    onChange={handleForm}
                    style={inputStyle}
                    placeholder="e.g. Class 5 Science Book"
                    required
                  />
                </FormGroup>

                <FormGroup label="Product Type">
                  <select
                    name="product_type"
                    value={form.product_type}
                    onChange={handleForm}
                    style={inputStyle}
                  >
                    <option value="general">General</option>
                    <option value="book">Book</option>
                    <option value="dress">Dress</option>
                    <option value="shoes">Shoes</option>
                  </select>
                </FormGroup>
              </div>

              {/* Variants */}
              <div style={{ marginTop: 24 }}>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                  <h3 style={{ margin: "10px 0", color: "#0f172a", fontWeight: 700 }}>Variants</h3>
                  <button type="button" onClick={addVariantRow} style={btnGhost}>
                    <FaPlus />&nbsp;Add Row
                  </button>
                </div>

                <div style={{ display: "grid", gap: 14 }}>
                  {variants.map((v, idx) => {
                    const isBook  = form.product_type === "book";
                    const isDress = form.product_type === "dress";
                    const isShoes = form.product_type === "shoes";

                    return (
                      <div key={idx} style={variantRow}>
                        <div style={gridAuto}>
                          <div>
                            <label style={smallLabel}>Variant Name</label>
                            <input
                              type="text"
                              value={v.variant_name}
                              onChange={(e) => handleVariantChange(idx, "variant_name", e.target.value)}
                              style={inputStyle}
                              placeholder="e.g. Class 5 Set / Size M / 9 UK"
                              required
                            />
                          </div>

                          {/* Book: searchable class */}
                          {isBook && (
                            <div>
                              <label style={smallLabel}>Class (searchable)</label>
                              {/* datalist: টাইপ করলে সার্চ হবে */}
                              <input
                                list={`class-list-${idx}`}
                                value={v.class_name}
                                onChange={(e) => handleClassPick(idx, e.target.value)}
                                style={inputStyle}
                                placeholder="Type to search class..."
                              />
                              <datalist id={`class-list-${idx}`}>
                                {classes.map(cls => (
                                  <option key={cls.id} value={cls.class_name} />
                                ))}
                              </datalist>
                              {/* hint দেখানোর জন্য */}
                              {v.class_id === "" && v.class_name && (
                                <small style={{ color: "#64748b" }}>
                                  {`Press Enter to select; matched id: ${
                                    (classes.find(c => c.class_name.toLowerCase() === v.class_name.toLowerCase())?.id) || "—"
                                  }`}
                                </small>
                              )}
                            </div>
                          )}

                          {/* Dress */}
                          {isDress && (
                            <>
                              <div>
                                <label style={smallLabel}>Height Range</label>
                                <input
                                  type="text"
                                  value={v.height_range}
                                  onChange={(e) => handleVariantChange(idx, "height_range", e.target.value)}
                                  style={inputStyle}
                                  placeholder="e.g. 120-130 cm"
                                />
                              </div>
                              <div>
                                <label style={smallLabel}>Weight Range</label>
                                <input
                                  type="text"
                                  value={v.weight_range}
                                  onChange={(e) => handleVariantChange(idx, "weight_range", e.target.value)}
                                  style={inputStyle}
                                  placeholder="e.g. 25-30 kg"
                                />
                              </div>
                            </>
                          )}

                          {/* Shoes */}
                          {isShoes && (
                            <div>
                              <label style={smallLabel}>Size</label>
                              <input
                                type="text"
                                value={v.size}
                                onChange={(e) => handleVariantChange(idx, "size", e.target.value)}
                                style={inputStyle}
                                placeholder="e.g. 7, 8, 9 UK"
                              />
                            </div>
                          )}

                          <div>
                            <label style={smallLabel}>Cost Price</label>
                            <input
                              type="number"
                              value={v.cost_price}
                              onChange={(e) => handleVariantChange(idx, "cost_price", e.target.value)}
                              style={inputStyle}
                              placeholder="0.00"
                              required
                            />
                          </div>

                          <div>
                            <label style={smallLabel}>Sale Price</label>
                            <input
                              type="number"
                              value={v.sale_price}
                              onChange={(e) => handleVariantChange(idx, "sale_price", e.target.value)}
                              style={inputStyle}
                              placeholder="0.00"
                              required
                            />
                          </div>

                          <div>
                            <label style={smallLabel}>Initial Stock</label>
                            <input
                              type="number"
                              value={v.initial_stock_qty}
                              onChange={(e) => handleVariantChange(idx, "initial_stock_qty", e.target.value)}
                              style={inputStyle}
                              placeholder="0"
                            />
                          </div>
                        </div>

                        {variants.length > 1 && (
                          <button type="button" onClick={() => removeVariantRow(idx)} style={btnDanger} title="Remove row">
                            <FaTrash />
                          </button>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>

              <div style={{ textAlign: "right", marginTop: 22 }}>
                <button type="submit" style={buttonStyle}>Create Bundle</button>
              </div>
            </form>
          </section>
        </main>
      </div>
    </div>
  );
};

/* -------- styles (spacing/gap tuned so inputs don’t “touch”) -------- */
const grid2     = { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20 };
const gridAuto  = { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(190px, 1fr))", gap: 16 };

const variantRow = {
  background: "#f8fafc",
  border: "1px solid #e5e7eb",
  padding: 16,
  borderRadius: 12,
  position: "relative",
};

const inputStyle = {
  width: "95%",
  padding: "10px 12px",
  borderRadius: 10,
  border: "1px solid #cbd5e1",
  background: "#fff",
  outline: "none",
  transition: "border .15s ease",
};

const smallLabel  = { fontSize: 12, color: "#475569", display: "block", marginBottom: 6 };

const btnGhost = {
  padding: "8px 14px",
  background: "#e2e8f0",
  border: "none",
  borderRadius: 10,
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  gap: 6
};

const btnDanger = {
  padding: 10,
  background: "#fee2e2",
  border: "none",
  borderRadius: 10,
  cursor: "pointer",
  color: "#b91c1c",
  position: "absolute",
  top: 0,
  right: 0
};

const cardStyle = {
  background: "#ffffff",
  padding: 26,
  borderRadius: 14,
  boxShadow: "0 8px 30px rgba(2,6,23,.06)",
  marginBottom: 30,
};

const titleStyle = { color: "#0f172a", marginBottom: 18, fontWeight: 800, fontSize: 22 };

const buttonStyle = {
  padding: "11px 22px",
  backgroundColor: "#0ea5e9",
  color: "#fff",
  border: "none",
  borderRadius: "10px",
  fontSize: "15px",
  fontWeight: 700,
  cursor: "pointer",
  transition: "transform .06s ease, background .2s ease",
};

const FormGroup = ({ label, children }) => (
  <div>
    <label style={{ display: "block", marginBottom: 6, color: "#334155", fontWeight: 600 }}>
      {label}
    </label>
    {children}
  </div>
);

export default ProductBundleCreate;
